import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayMobileHeaderBarClockIconBox} from "../../boxes/clock-icon/game-play-mobile-header-bar-clock-icon.box";
import {CyClass} from "../../../../../../../../common/cy-classes";
import {GamePlayMobileHeaderBarClockBox} from "../../boxes/clock/game-play-mobile-header-bar-clock.box";
import React from "react";
import {observer} from "mobx-react";
import {ClockComponent} from "../../../../../../clock/clock.component";


export const GamePlayMobileHeaderBarClockComponent = observer(
    class GamePlayMobileHeaderBarClockComponent extends OrbitComponent<{hideClockIcon?: boolean}> {
        private _renderClockIcon = () => {
            if(this.props.hideClockIcon) {
                return null;
            }
            return (<GamePlayMobileHeaderBarClockIconBox/>);
        }
        render() {
            return (
                <GamePlayMobileHeaderBarClockBox>
                    {this._renderClockIcon()}
                    <ClockComponent
                        className={CyClass('cy-game-stripe-clock')}
                        box={GamePlayMobileHeaderBarClockBox}
                    />
                </GamePlayMobileHeaderBarClockBox>
            );
        }
    }
);